// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var $$String = require("rescript/lib/js/string.js");
var Caml_obj = require("rescript/lib/js/caml_obj.js");
var Js_array = require("rescript/lib/js/js_array.js");
var Belt_List = require("rescript/lib/js/belt_List.js");
var Belt_Option = require("rescript/lib/js/belt_Option.js");
var Json_decode = require("@glennsl/bs-json/src/Json_decode.res.js");
var Json_encode = require("@glennsl/bs-json/src/Json_encode.res.js");

function decodeEnds(json) {
  return {
          type_: Json_decode.field("type", Json_decode.string, json),
          count: Json_decode.optional((function (param) {
                  return Json_decode.field("count", Json_decode.$$int, param);
                }), json),
          date: Json_decode.optional((function (param) {
                  return Json_decode.field("date", Json_decode.string, param);
                }), json)
        };
}

function decodeRecurrence(json) {
  return {
          preset: Json_decode.field("preset", Json_decode.string, json),
          frequency: Json_decode.field("frequency", Json_decode.string, json),
          interval: Belt_Option.getWithDefault(Json_decode.optional((function (param) {
                      return Json_decode.field("interval", Json_decode.$$int, param);
                    }), json), 1),
          byDay: Belt_Option.getWithDefault(Json_decode.optional((function (param) {
                      return Json_decode.field("by_day", (function (param) {
                                    return Json_decode.list(Json_decode.string, param);
                                  }), param);
                    }), json), /* [] */0),
          byMonthDay: Json_decode.optional((function (param) {
                  return Json_decode.field("by_month_day", Json_decode.$$int, param);
                }), json),
          ends: Json_decode.field("ends", decodeEnds, json)
        };
}

function decodeReportOption(json) {
  return {
          id: Json_decode.field("id", Json_decode.$$int, json),
          name: Json_decode.field("name", Json_decode.string, json),
          timeFrame: Json_decode.optional((function (param) {
                  return Json_decode.field("time_frame", Json_decode.string, param);
                }), json)
        };
}

function reportOptionName(r) {
  return r.name;
}

function reportOptionTimeFrame(r) {
  return r.timeFrame;
}

function decodePlaceholderChip(json) {
  return {
          token: Json_decode.field("token", Json_decode.string, json),
          example: Json_decode.field("example", Json_decode.string, json)
        };
}

function empty(param) {
  return {
          id: undefined,
          name: "",
          schedule: "",
          frequency: "",
          sendTime: "",
          weekday: undefined,
          dayOfMonth: undefined,
          recurrence: {
            preset: "",
            frequency: "",
            interval: 1,
            byDay: /* [] */0,
            byMonthDay: undefined,
            ends: {
              type_: "never",
              count: undefined,
              date: undefined
            }
          },
          recurrenceSummary: undefined,
          toEmails: /* [] */0,
          fromEmail: "",
          ccEmails: /* [] */0,
          bccEmails: /* [] */0,
          recipientRoleNames: undefined,
          subject: "",
          body: undefined,
          deliveryFormat: "auto",
          attachmentThresholdRows: 60,
          reportIds: /* [] */0,
          reports: /* [] */0
        };
}

function id(t) {
  return t.id;
}

function name(t) {
  return t.name;
}

function schedule(t) {
  return t.schedule;
}

function frequency(t) {
  return t.frequency;
}

function sendTime(t) {
  return t.sendTime;
}

function weekday(t) {
  return t.weekday;
}

function dayOfMonth(t) {
  return t.dayOfMonth;
}

function recurrence(t) {
  return t.recurrence;
}

function recurrenceSummary(t) {
  return t.recurrenceSummary;
}

function toEmails(t) {
  return t.toEmails;
}

function fromEmail(t) {
  return t.fromEmail;
}

function ccEmails(t) {
  return t.ccEmails;
}

function bccEmails(t) {
  return t.bccEmails;
}

function subject(t) {
  return t.subject;
}

function body(t) {
  return t.body;
}

function deliveryFormat(t) {
  return t.deliveryFormat;
}

function attachmentThresholdRows(t) {
  return t.attachmentThresholdRows;
}

function reportIds(t) {
  return t.reportIds;
}

function reports(t) {
  return t.reports;
}

function scheduleForFrequency(frequency) {
  switch (frequency) {
    case "day" :
        return "beginning_of_day";
    case "month" :
        return "beginning_of_month";
    case "week" :
        return "beginning_of_week";
    default:
      return "";
  }
}

function presetRecurrence(preset, frequency, weekday, dayOfMonth, param) {
  var byDay = weekday !== undefined ? ({
        hd: weekday,
        tl: /* [] */0
      }) : /* [] */0;
  return {
          preset: preset,
          frequency: frequency,
          interval: 1,
          byDay: byDay,
          byMonthDay: dayOfMonth,
          ends: {
            type_: "never",
            count: undefined,
            date: undefined
          }
        };
}

function setRecurrence(t, recurrence) {
  var newrecord = Caml_obj.obj_dup(t);
  var t$1 = (newrecord.recurrence = recurrence, newrecord);
  var match = t$1.recurrence.byDay;
  var weekday = match ? match.hd : undefined;
  var newrecord$1 = Caml_obj.obj_dup(t$1);
  newrecord$1.dayOfMonth = t$1.recurrence.byMonthDay;
  newrecord$1.weekday = weekday;
  newrecord$1.frequency = t$1.recurrence.frequency;
  newrecord$1.schedule = scheduleForFrequency(t$1.recurrence.frequency);
  return newrecord$1;
}

function setName(t, name) {
  var newrecord = Caml_obj.obj_dup(t);
  newrecord.name = name;
  return newrecord;
}

function setSchedule(t, schedule) {
  var newrecord = Caml_obj.obj_dup(t);
  newrecord.schedule = schedule;
  return newrecord;
}

function setFrequency(t, frequency) {
  var newrecord = Caml_obj.obj_dup(t);
  newrecord.frequency = frequency;
  return newrecord;
}

function setSendTime(t, sendTime) {
  var newrecord = Caml_obj.obj_dup(t);
  newrecord.sendTime = sendTime;
  return newrecord;
}

function setWeekday(t, weekday) {
  var newrecord = Caml_obj.obj_dup(t);
  newrecord.weekday = weekday;
  return newrecord;
}

function setDayOfMonth(t, dayOfMonth) {
  var newrecord = Caml_obj.obj_dup(t);
  newrecord.dayOfMonth = dayOfMonth;
  return newrecord;
}

function setToEmails(t, toEmails) {
  var newrecord = Caml_obj.obj_dup(t);
  newrecord.toEmails = toEmails;
  return newrecord;
}

function setFromEmail(t, fromEmail) {
  var newrecord = Caml_obj.obj_dup(t);
  newrecord.fromEmail = fromEmail;
  return newrecord;
}

function setCcEmails(t, ccEmails) {
  var newrecord = Caml_obj.obj_dup(t);
  newrecord.ccEmails = ccEmails;
  return newrecord;
}

function setBccEmails(t, bccEmails) {
  var newrecord = Caml_obj.obj_dup(t);
  newrecord.bccEmails = bccEmails;
  return newrecord;
}

function recipientRoleNames(t) {
  return t.recipientRoleNames;
}

function setRecipientRoleNames(t, recipientRoleNames) {
  var newrecord = Caml_obj.obj_dup(t);
  newrecord.recipientRoleNames = recipientRoleNames;
  return newrecord;
}

function setSubject(t, subject) {
  var newrecord = Caml_obj.obj_dup(t);
  newrecord.subject = subject;
  return newrecord;
}

function setBody(t, body) {
  var newrecord = Caml_obj.obj_dup(t);
  newrecord.body = body;
  return newrecord;
}

function setDeliveryFormat(t, deliveryFormat) {
  var newrecord = Caml_obj.obj_dup(t);
  newrecord.deliveryFormat = deliveryFormat;
  return newrecord;
}

function setAttachmentThresholdRows(t, attachmentThresholdRows) {
  var newrecord = Caml_obj.obj_dup(t);
  newrecord.attachmentThresholdRows = attachmentThresholdRows;
  return newrecord;
}

function setReportIds(t, reportIds) {
  var newrecord = Caml_obj.obj_dup(t);
  newrecord.reportIds = reportIds;
  return newrecord;
}

function applyPreset(t, preset) {
  var recurrence;
  switch (preset) {
    case "daily" :
        recurrence = presetRecurrence("daily", "day", undefined, undefined, undefined);
        break;
    case "monthly" :
        recurrence = presetRecurrence("monthly", "month", undefined, Belt_Option.orElse(t.dayOfMonth, 1), undefined);
        break;
    case "weekly" :
        recurrence = presetRecurrence("weekly", "week", Belt_Option.orElse(t.weekday, "monday"), undefined, undefined);
        break;
    default:
      recurrence = {
        preset: "custom",
        frequency: "week",
        interval: 1,
        byDay: {
          hd: "monday",
          tl: /* [] */0
        },
        byMonthDay: undefined,
        ends: {
          type_: "never",
          count: undefined,
          date: undefined
        }
      };
  }
  return setRecurrence(t, recurrence);
}

function toggleByDay(rule, day) {
  var updated = Belt_List.some(rule.byDay, (function (d) {
          return d === day;
        })) ? Belt_List.keep(rule.byDay, (function (d) {
            return d !== day;
          })) : Belt_List.add(rule.byDay, day);
  return {
          preset: rule.preset,
          frequency: rule.frequency,
          interval: rule.interval,
          byDay: updated,
          byMonthDay: rule.byMonthDay,
          ends: rule.ends
        };
}

function encodeEnds(ends) {
  var value = ends.count;
  var countPair = value !== undefined ? ({
        hd: [
          "count",
          value
        ],
        tl: /* [] */0
      }) : /* [] */0;
  var value$1 = ends.date;
  var datePair = value$1 !== undefined ? ({
        hd: [
          "date",
          value$1
        ],
        tl: /* [] */0
      }) : /* [] */0;
  return Json_encode.object_(Belt_List.concat(datePair, Belt_List.concat(countPair, {
                      hd: [
                        "type",
                        ends.type_
                      ],
                      tl: /* [] */0
                    })));
}

function encodeRecurrence(recurrence) {
  var value = recurrence.byMonthDay;
  var monthDayPair = value !== undefined ? ({
        hd: [
          "by_month_day",
          value
        ],
        tl: /* [] */0
      }) : /* [] */0;
  return Json_encode.object_(Belt_List.concat(monthDayPair, {
                  hd: [
                    "preset",
                    recurrence.preset
                  ],
                  tl: {
                    hd: [
                      "frequency",
                      recurrence.frequency
                    ],
                    tl: {
                      hd: [
                        "interval",
                        recurrence.interval
                      ],
                      tl: {
                        hd: [
                          "by_day",
                          Json_encode.list((function (prim) {
                                  return prim;
                                }), recurrence.byDay)
                        ],
                        tl: {
                          hd: [
                            "ends",
                            encodeEnds(recurrence.ends)
                          ],
                          tl: /* [] */0
                        }
                      }
                    }
                  }
                }));
}

function decode(json) {
  var frequencyValue = Belt_Option.getWithDefault(Json_decode.optional((function (param) {
              return Json_decode.field("frequency", Json_decode.string, param);
            }), json), "");
  var weekdayValue = Json_decode.optional((function (param) {
          return Json_decode.field("weekday", Json_decode.string, param);
        }), json);
  var dayOfMonthValue = Json_decode.optional((function (param) {
          return Json_decode.field("day_of_month", Json_decode.$$int, param);
        }), json);
  var __x = Json_decode.optional((function (param) {
          return Json_decode.field("recurrence", decodeRecurrence, param);
        }), json);
  var tmp;
  switch (frequencyValue) {
    case "day" :
        tmp = presetRecurrence("daily", "day", undefined, undefined, undefined);
        break;
    case "month" :
        tmp = presetRecurrence("monthly", "month", undefined, dayOfMonthValue, undefined);
        break;
    case "week" :
        tmp = presetRecurrence("weekly", "week", weekdayValue, undefined, undefined);
        break;
    default:
      tmp = {
        preset: "",
        frequency: "",
        interval: 1,
        byDay: /* [] */0,
        byMonthDay: undefined,
        ends: {
          type_: "never",
          count: undefined,
          date: undefined
        }
      };
  }
  var recurrenceValue = Belt_Option.getWithDefault(__x, tmp);
  return {
          id: Json_decode.field("id", (function (param) {
                  return Json_decode.optional(Json_decode.$$int, param);
                }), json),
          name: Json_decode.field("name", Json_decode.string, json),
          schedule: Json_decode.field("schedule", Json_decode.string, json),
          frequency: frequencyValue,
          sendTime: Belt_Option.getWithDefault(Json_decode.optional((function (param) {
                      return Json_decode.field("send_time", Json_decode.string, param);
                    }), json), ""),
          weekday: weekdayValue,
          dayOfMonth: dayOfMonthValue,
          recurrence: recurrenceValue,
          recurrenceSummary: Json_decode.optional((function (param) {
                  return Json_decode.field("recurrence_summary", Json_decode.string, param);
                }), json),
          toEmails: Json_decode.field("to_emails", (function (param) {
                  return Json_decode.list(Json_decode.string, param);
                }), json),
          fromEmail: Json_decode.field("from_email", Json_decode.string, json),
          ccEmails: Belt_Option.getWithDefault(Json_decode.optional((function (param) {
                      return Json_decode.field("cc_emails", (function (param) {
                                    return Json_decode.list(Json_decode.string, param);
                                  }), param);
                    }), json), /* [] */0),
          bccEmails: Belt_Option.getWithDefault(Json_decode.optional((function (param) {
                      return Json_decode.field("bcc_emails", (function (param) {
                                    return Json_decode.list(Json_decode.string, param);
                                  }), param);
                    }), json), /* [] */0),
          recipientRoleNames: Json_decode.optional((function (param) {
                  return Json_decode.field("recipient_role_names", (function (param) {
                                return Json_decode.list(Json_decode.string, param);
                              }), param);
                }), json),
          subject: Belt_Option.getWithDefault(Json_decode.optional((function (param) {
                      return Json_decode.field("subject", Json_decode.string, param);
                    }), json), ""),
          body: Json_decode.optional((function (param) {
                  return Json_decode.field("body", Json_decode.string, param);
                }), json),
          deliveryFormat: Belt_Option.getWithDefault(Json_decode.optional((function (param) {
                      return Json_decode.field("delivery_format", Json_decode.string, param);
                    }), json), "auto"),
          attachmentThresholdRows: Belt_Option.getWithDefault(Json_decode.optional((function (param) {
                      return Json_decode.field("attachment_threshold_rows", Json_decode.$$int, param);
                    }), json), 60),
          reportIds: Belt_Option.getWithDefault(Json_decode.optional((function (param) {
                      return Json_decode.field("report_ids", (function (param) {
                                    return Json_decode.list(Json_decode.$$int, param);
                                  }), param);
                    }), json), /* [] */0),
          reports: Belt_Option.getWithDefault(Json_decode.optional((function (param) {
                      return Json_decode.field("reports", (function (param) {
                                    return Json_decode.list(decodeReportOption, param);
                                  }), param);
                    }), json), /* [] */0)
        };
}

function encode(t) {
  var d = t.dayOfMonth;
  var dayOfMonthPairs = d !== undefined ? ({
        hd: [
          "day_of_month",
          d
        ],
        tl: /* [] */0
      }) : /* [] */0;
  var w = t.weekday;
  var weekdayPairs = w !== undefined ? ({
        hd: [
          "weekday",
          w
        ],
        tl: /* [] */0
      }) : /* [] */0;
  return Json_encode.object_(Belt_List.concat(dayOfMonthPairs, Belt_List.concat(weekdayPairs, {
                      hd: [
                        "name",
                        t.name
                      ],
                      tl: {
                        hd: [
                          "schedule",
                          t.schedule
                        ],
                        tl: {
                          hd: [
                            "frequency",
                            t.frequency
                          ],
                          tl: {
                            hd: [
                              "send_time",
                              t.sendTime
                            ],
                            tl: {
                              hd: [
                                "recurrence",
                                encodeRecurrence(t.recurrence)
                              ],
                              tl: {
                                hd: [
                                  "to_emails",
                                  Json_encode.list((function (prim) {
                                          return prim;
                                        }), t.toEmails)
                                ],
                                tl: {
                                  hd: [
                                    "from_email",
                                    t.fromEmail
                                  ],
                                  tl: {
                                    hd: [
                                      "cc_emails",
                                      Json_encode.list((function (prim) {
                                              return prim;
                                            }), t.ccEmails)
                                    ],
                                    tl: {
                                      hd: [
                                        "bcc_emails",
                                        Json_encode.list((function (prim) {
                                                return prim;
                                              }), t.bccEmails)
                                      ],
                                      tl: {
                                        hd: [
                                          "recipient_role_names",
                                          Json_encode.list((function (prim) {
                                                  return prim;
                                                }), Belt_Option.getWithDefault(t.recipientRoleNames, /* [] */0))
                                        ],
                                        tl: {
                                          hd: [
                                            "subject",
                                            t.subject
                                          ],
                                          tl: {
                                            hd: [
                                              "body",
                                              Belt_Option.getWithDefault(t.body, "")
                                            ],
                                            tl: {
                                              hd: [
                                                "delivery_format",
                                                t.deliveryFormat
                                              ],
                                              tl: {
                                                hd: [
                                                  "attachment_threshold_rows",
                                                  t.attachmentThresholdRows
                                                ],
                                                tl: {
                                                  hd: [
                                                    "report_ids",
                                                    Json_encode.list((function (prim) {
                                                            return prim;
                                                          }), t.reportIds)
                                                  ],
                                                  tl: /* [] */0
                                                }
                                              }
                                            }
                                          }
                                        }
                                      }
                                    }
                                  }
                                }
                              }
                            }
                          }
                        }
                      }
                    })));
}

function isRecurrenceValid(rule) {
  if (rule.preset === "" || rule.frequency === "" || rule.interval < 1) {
    return false;
  }
  var match = rule.frequency;
  var tmp;
  switch (match) {
    case "day" :
        tmp = true;
        break;
    case "month" :
        var day = rule.byMonthDay;
        tmp = day !== undefined ? day >= 1 && day <= 31 : false;
        break;
    case "week" :
        tmp = Belt_List.length(rule.byDay) > 0;
        break;
    default:
      tmp = false;
  }
  if (!tmp) {
    return false;
  }
  var match$1 = rule.ends.type_;
  switch (match$1) {
    case "after" :
        var count = rule.ends.count;
        if (count !== undefined) {
          return count > 0;
        } else {
          return false;
        }
    case "never" :
        return true;
    case "on" :
        return Belt_Option.isSome(rule.ends.date);
    default:
      return false;
  }
}

function monthDayLabel(rule) {
  var day = rule.byMonthDay;
  if (day !== undefined) {
    return " on day " + String(day);
  } else {
    return "";
  }
}

function weekDayLabel(rule) {
  var daysArray = Belt_List.toArray(Belt_List.map(rule.byDay, $$String.capitalize_ascii));
  var days = Js_array.joinWith(", ", daysArray);
  if (days === "") {
    return "";
  } else {
    return " on " + days;
  }
}

function previewSummary(rule, sendTime, timeZone) {
  var match = rule.frequency;
  var unit;
  switch (match) {
    case "day" :
        unit = "day";
        break;
    case "month" :
        unit = "month";
        break;
    case "week" :
        unit = "week";
        break;
    default:
      unit = "period";
  }
  var intervalLabel;
  if (rule.interval <= 1) {
    var match$1 = rule.frequency;
    switch (match$1) {
      case "day" :
          intervalLabel = "Daily";
          break;
      case "month" :
          intervalLabel = "Monthly";
          break;
      case "week" :
          intervalLabel = "Weekly";
          break;
      default:
        intervalLabel = "Custom";
    }
  } else {
    intervalLabel = "Every " + String(rule.interval) + " " + unit + "s";
  }
  var match$2 = rule.frequency;
  var dayLabel;
  switch (match$2) {
    case "month" :
        dayLabel = monthDayLabel(rule);
        break;
    case "week" :
        dayLabel = weekDayLabel(rule);
        break;
    default:
      dayLabel = "";
  }
  var timeLabel = sendTime === "" ? "" : " at " + sendTime;
  var zoneLabel = " (" + timeZone + ")";
  return intervalLabel + dayLabel + timeLabel + zoneLabel;
}

exports.empty = empty;
exports.id = id;
exports.name = name;
exports.schedule = schedule;
exports.frequency = frequency;
exports.sendTime = sendTime;
exports.weekday = weekday;
exports.dayOfMonth = dayOfMonth;
exports.recurrence = recurrence;
exports.recurrenceSummary = recurrenceSummary;
exports.toEmails = toEmails;
exports.fromEmail = fromEmail;
exports.ccEmails = ccEmails;
exports.bccEmails = bccEmails;
exports.subject = subject;
exports.body = body;
exports.deliveryFormat = deliveryFormat;
exports.attachmentThresholdRows = attachmentThresholdRows;
exports.reportIds = reportIds;
exports.reports = reports;
exports.setName = setName;
exports.setSchedule = setSchedule;
exports.setFrequency = setFrequency;
exports.setSendTime = setSendTime;
exports.setWeekday = setWeekday;
exports.setDayOfMonth = setDayOfMonth;
exports.setRecurrence = setRecurrence;
exports.applyPreset = applyPreset;
exports.toggleByDay = toggleByDay;
exports.setToEmails = setToEmails;
exports.setFromEmail = setFromEmail;
exports.setCcEmails = setCcEmails;
exports.setBccEmails = setBccEmails;
exports.recipientRoleNames = recipientRoleNames;
exports.setRecipientRoleNames = setRecipientRoleNames;
exports.setSubject = setSubject;
exports.setBody = setBody;
exports.setDeliveryFormat = setDeliveryFormat;
exports.setAttachmentThresholdRows = setAttachmentThresholdRows;
exports.setReportIds = setReportIds;
exports.decode = decode;
exports.encode = encode;
exports.isRecurrenceValid = isRecurrenceValid;
exports.previewSummary = previewSummary;
exports.decodeReportOption = decodeReportOption;
exports.reportOptionName = reportOptionName;
exports.reportOptionTimeFrame = reportOptionTimeFrame;
exports.decodePlaceholderChip = decodePlaceholderChip;
/* No side effect */
